import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = {
  class: "container"
};
const _hoisted_2 = {
  class: "about"
};
const _hoisted_3 = {
  class: "list"
};
const _hoisted_4 = ["src"];
const _hoisted_5 = {
  class: "item-title"
};
import { ref } from 'vue';
export default {
  __name: 'index',
  setup(__props) {
    const list = ref([{
      img: require('@/assets/img12.png'),
      title: '2023年金华市第一季度普惠券发放'
    }, {
      img: require('@/assets/img13.png'),
      title: '2023年金华市第一季度家电券发放'
    }, {
      img: require('@/assets/img14.png'),
      title: '2023年金华市第一季度家文旅券放'
    }, {
      img: require('@/assets/img15.png'),
      title: '2023年金华市第一季度购车补贴发放'
    }, {
      img: require('@/assets/img16.png'),
      title: '2023年金华市数字人民币红包发放'
    }, {
      img: require('@/assets/img17.png'),
      title: '2023年永康市五金券发放'
    }]);
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock(_Fragment, null, [_cache[2] || (_cache[2] = _createElementVNode("div", {
        class: "banner"
      }, null, -1)), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[0] || (_cache[0] = _createElementVNode("div", {
        class: "us-title"
      }, "EXCELLECT CASES", -1)), _cache[1] || (_cache[1] = _createElementVNode("h3", {
        class: "title"
      }, "发券案例", -1)), _createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, item => {
        return _openBlock(), _createElementBlock("div", {
          class: "list-item",
          key: item.title
        }, [_createElementVNode("img", {
          src: item.img,
          style: {
            "width": "385px",
            "height": "200px"
          },
          alt: ""
        }, null, 8, _hoisted_4), _createElementVNode("div", _hoisted_5, _toDisplayString(item.title), 1)]);
      }), 128))])])])], 64);
    };
  }
};